// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3RvJW","label":"Radio_label__17HqG","checkMark":"Radio_checkMark__320Ab","disabled":"Radio_disabled__3f0Cn"};